<!-- Created by henian.xu on 2020/3/26. -->

<template>
    <div
        class="invoice-item"
        v-bind="linkerProps"
        v-on="excludeInputListeners"
    >
        <div class="header">
            <XIcon
                content="f093"
                theme="main"
            />
            <XLabel>{{data.invoiceTitle}}</XLabel>
        </div>
        <div class="body">
            <div class="inner">
                <dl>
                    <dt>发票类型:</dt>
                    <dd>{{data.invoiceTypeName}}</dd>
                </dl>
                <dl>
                    <dt>金　　额:</dt>
                    <dd class="price">{{data.invoiceAmount}}</dd>
                </dl>
                <dl>
                    <dt>申请时间:</dt>
                    <dd>{{data.invoiceTime | moment}}</dd>
                </dl>
            </div>
            <XIcon
                content="f012"
                size="small"
                theme="g5"
            />
        </div>
        <div class="footer">
            <XButton
                :label="data.invoiceStatusName"
                link
            />
        </div>
    </div>
</template>

<script>
import { linkerMixin, listenersMixin } from 'packages/mixins';

export default {
    name: 'InvoiceItem',
    mixins: [linkerMixin, listenersMixin],
    data() {
        return {};
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {},
};
</script>

<style lang="scss">
.invoice-item {
    display: block;
    background-color: $color-component-bgc;
    //border-radius: $padding;
    border: 1px solid $color-border;
    overflow: hidden;
    @include boxShadow();

    > .header {
        margin: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > .x-icon {
            margin-right: $margin-small;
        }
        > .x-label {
            flex: 1;
            font-weight: bold;
        }
    }
    > .body {
        margin: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > .inner {
            flex: 1;
            dl {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                + dl {
                    margin-top: $margin-small;
                }
                > dt {
                    flex: 0 0 auto;
                }
                > dd {
                    flex: 1;
                }
            }
        }
    }
    > .footer {
        margin: $padding 0;
        text-align: right;
    }
}
</style>
